export default function initHeaderScale() {
  // Debounce to limit the frequency of function execution
  const debounce = (callback, delay = 100) => {
    let timeout;
    return () => {
      clearTimeout(timeout);
      timeout = setTimeout(callback, delay);
    };
  };

  const header = document.getElementById("header");
  if (!header) {
    console.error("Header element not found!");
    return;
  }

  const pageHeader = document.getElementById('main')?.firstElementChild;
  if (!pageHeader) {
    console.error("Page header element not found!");
    return;
  }

  const SCROLL_THRESHOLD = 100;
  let headerHeight = header.offsetHeight;
  let pageHeaderHeight = pageHeader.offsetHeight - headerHeight;

  // Set CSS variables to store header height
  const setHeaderHeight = function () {
    headerHeight = header.offsetHeight;
    pageHeaderHeight = pageHeader.offsetHeight - headerHeight;
    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
    console.cclog("HEADER HEIGHT: " + headerHeight);
  };

  // Check scroll position and toggle classes
  function checkScroll() {
    const scrollPosition = window.scrollY;
    let headerHeightScrolled = header.offsetHeight;
    document.documentElement.style.setProperty("--header-height-scrolled", `${headerHeightScrolled}px`);
    console.cclog("HEADER HEIGHT SCROLLED: " + headerHeightScrolled);

    if (scrollPosition > headerHeight + SCROLL_THRESHOLD) {
      document.body.classList.add('scrolled-down');
    } else {
      document.body.classList.remove('scrolled-down');
    }

    if (scrollPosition > pageHeaderHeight) {
      document.body.classList.add('scrolled-past-ctas');
    } else {
      document.body.classList.remove('scrolled-past-ctas');
    }
  }

  // Initial page load function
  function onPageLoad() {
    setHeaderHeight();
    checkScroll();
  }

  // Call onPageLoad directly since ready() ensures the DOM is loaded
  onPageLoad();

  window.addEventListener("scroll", debounce(checkScroll, 100));
  window.addEventListener("resize", debounce(setHeaderHeight, 100));
}
